import SetupController from 'cio/pods/base/setup/controller';
export default SetupController;

declare module '@ember/controller' {
  interface Registry {
    'broadcasts.broadcast.setup': SetupController;
  }
}
